import {StyleSheet} from 'react-native';
import CCColors, {updateColorWithOpacity} from '../../Utils/CCColors';
import {isPhone} from '@/Utils/Dimensions';

export const styles = StyleSheet.create({
  container: {
    height: '100vh',
    backgroundColor: CCColors.Primary.lightBrown,
    paddingTop: 38,
    paddingHorizontal: isPhone ? 16 : 32,
    paddingBottom: 32,
    gap: 30,
  },
  innerContainer: {
    height: '70vh',
    flexDirection: 'row',
    gap: 24,
  },
  leftPanel: {
    flex: 1,
    paddingTop: 20,
    paddingBottom: 15,
    borderRadius: 8,
    backgroundColor: CCColors.White,
  },
  searchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginLeft: 24,
    marginRight: 16,
    marginBottom: 20,
    zIndex: 10,
  },
  rightPanel: {
    flex: 2,
    borderRadius: 8,
    backgroundColor: CCColors.White,
  },
  rightPanelHeader: {
    width: '100%',
    paddingLeft: 24,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: CCColors.Box.MiddleLine,
  },
  detailsContainer: {
    flex: 1,
    width: '100%',
  },
  chatBody: {
    flex: 1,
    maxHeight: 7 * 90,
  },
  chatContent: {
    paddingHorizontal: 24,
    gap: 12,
    flexGrow: 1,
    justifyContent: 'flex-start',
  },
  messageRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginVertical: 4,
  },
  leftRow: {
    justifyContent: 'flex-start',
  },
  rightRow: {
    justifyContent: 'flex-end',
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: CCColors?.LightBrownShade,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 6,
  },
  avatarText: {
    fontWeight: '700',
  },
  chatBubbleLeft: {
    alignSelf: 'flex-start',
    paddingVertical: 16,
    paddingHorizontal: isPhone ? 16 : 24,
    borderWidth: 1,
    borderColor: CCColors.BorderBottom,
    borderRadius: 8,
  },
  chatBubbleRight: {
    alignSelf: 'flex-end',
    backgroundColor: CCColors.Primary.lightBrown,
    paddingVertical: 16,
    paddingHorizontal: isPhone ? 16 : 24,
    borderWidth: 1,
    borderColor: CCColors.BorderBottom,
    borderRadius: 8,
  },
  /** Inbox: sender name at top of bubble (legacy, kept for reference) */
  inboxSenderLabel: {
    marginBottom: 4,
  },
  /** Inbox: sender name above bubble, outside it (alignment from parent Box) */
  inboxSenderLabelOuter: {
    marginBottom: 2,
  },
  /** Inbox: time row at bottom of bubble */
  inboxTimeRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 6,
    paddingTop: 4,
  },
  detailsText: {
    fontWeight: '400',
  },
  chatInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 8,
  },
  inputWrapper: {
    flex: 1,
    position: 'relative',
  },
  textInput: {
    borderRadius: 38,
    paddingHorizontal: 12,
    paddingRight: 40,
    backgroundColor: CCColors.White,
    borderWidth: 1,
    borderColor: CCColors.BorderBottom,
  },
  sendBtnInside: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: [{translateY: -20}],
    backgroundColor: CCColors.Primary.Default,
    height: 40,
    width: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  attachBtn: {
    marginLeft: 12,
    padding: 16,
    borderWidth: 1,
    borderColor: CCColors.BorderBottom,
    borderRadius: 38,
  },
  filePreviewContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f1f1f1',
    borderRadius: 10,
    marginTop: 8,
    marginHorizontal: 8,
    padding: 8,
    position: 'relative',
  },
  filePreviewImage: {
    width: 60,
    height: 60,
    borderRadius: 6,
  },
  filePreviewVideo: {
    width: 80,
    height: 60,
    borderRadius: 6,
  },
  fileName: {
    marginLeft: 8,
    color: '#333',
    fontSize: 14,
    flexShrink: 1,
  },
  removeFileBtn: {
    position: 'absolute',
    top: 4,
    right: 4,
    backgroundColor: '#00000088',
    borderRadius: 10,
    padding: 2,
  },
  filterButton: {
    width: 40,
    height: 40,
    padding: 10,
    borderRadius: 8,
    backgroundColor: CCColors.White,
    borderWidth: 1,
    borderColor: CCColors.Box.MiddleLine,
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 2,
  },
  dropdown: {
    position: 'absolute',
    top: 45,
    right: 0,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: CCColors.Box.MiddleLine,
    backgroundColor: CCColors.White,
    shadowColor: CCColors.Primary.Dark,
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 10,
    zIndex: 9999,
    paddingVertical: 5,
    width: 150,
  },
  dropdownItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 15,
    gap: 8,
  },
  iconCircleMobile: {
    width: 14,
    height: 14,
    borderRadius: 10,
    borderWidth: 1.25,
    borderColor: CCColors.TextColor.Primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdownText: {
    fontSize: 14,
    color: CCColors.TextColor.Dark,
  },
  trailingIcon: {
    marginLeft: 'auto',
  },
  separator: {
    height: 1,
    backgroundColor: CCColors.Box.MiddleLine,
    marginHorizontal: 10,
  },
  ticketItem: {
    padding: 16,
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderBottomColor: CCColors.Box.MiddleLine,
    borderTopColor: CCColors.Box.MiddleLine,
  },
  ticketSelected: {
    backgroundColor: updateColorWithOpacity(CCColors.Primary.Default, 0.2),
    borderLeftWidth: 2,
    borderColor: CCColors.Primary.Default,
  },
  supportTicket: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  ticketTitle: {
    fontWeight: '400',
    marginBottom: 4,
  },
  ticketMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  unreadBadge: {
    backgroundColor: CCColors.Red,
    borderRadius: 4,
    paddingHorizontal: 6,
    paddingTop: 2.5,
    paddingBottom: 1.5,
  },
  statusBadge: {
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginBottom: 8,
  },
  Resolved: {
    backgroundColor: updateColorWithOpacity(CCColors.BlueAqua, 0.16),
  },
  ['In progress']: {
    backgroundColor: updateColorWithOpacity(CCColors.Pink, 0.16),
  },
  ['Not Seen']: {
    backgroundColor: updateColorWithOpacity(
      CCColors.WrongMoves.Background,
      0.16,
    ),
  },
  statusText: {
    fontWeight: '600',
  },
  emptyState: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  emptyText: {
    marginBottom: 4,
  },
  emptySubText: {
    fontWeight: '400',
    opacity: 0.7,
  },
  refresh: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 8,
    width: 30,
    height: 30,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: CCColors.Primary.Brown,
    justifyContent: 'center',
  },
  dateSeparator: {
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 16,
  },
  dateSeparatorText: {
    backgroundColor: CCColors.Transparent, // or any background color
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
    overflow: 'hidden',
  },
  support: {
    paddingHorizontal: 24,
    paddingVertical: 8,
  },
  supportbtn: {
    backgroundColor: CCColors.White,
  },
  img: {
    height: 18,
    width: 18,
  },
  vid: {
    flex: 1,
    backgroundColor: CCColors.ModalBg,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    position: 'absolute',
    top: 10,
    right: 20,
    zIndex: 10,
    padding: 10,
  },
  close: {color: CCColors.White, fontSize: 28},
  closeIcon: {position: 'absolute', top: 20, right: 20},
  bg: {
    flex: 1,
    backgroundColor: CCColors.ModalBg,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
